<template>
  <exclusive-offer-toast
    warning
    :message="emailFailedMessage"
    event="qualificationSentEmailFailedToast"
    class="qualification-transfer-email-failed-toast"
  />
</template>

<script>
import ExclusiveOfferToast from './ExclusiveOfferToast.vue'

import {
  events,
} from '@nuskin/ns-util'

export default {
  components: {
    ExclusiveOfferToast
  },
  data() {
    return {
      emailFailedMessage: '',
    }
  },
  mounted() {
    events.subscribe(events.shop.QUALIFICATION_SENT_EMAIL_FAILED, (message) => {
      this.emailFailedMessage = message

      events.publish('qualificationSentEmailFailedToast')
    })
  }
}
</script>
<style lang="scss" scoped>

</style>
